<template>
  <van-row class="foot-main">
   <van-row class="startbox">
      <van-row class="startbox-title">
        {{$t('m.cryTradingcye')}}
      </van-row>
      <van-row class="numtext">
        <van-col span="8" style="padding-left:.4rem">
          <van-row class="num">1</van-row>
          <van-row class="text">{{$t('m.register')}}</van-row>
          <van-row class="text" style="font-size:.32rem">{{$t('m.accountide')}}</van-row>
        </van-col>
        <van-col span="8" style="padding-left:.4rem">
          <van-row class="num">2</van-row>
          <van-row class="text">{{$t('m.Deposi')}}</van-row>
          <van-row class="text" style="font-size:.32rem">{{$t('m.cardInvest')}}</van-row>

        </van-col>
        <van-col span="8" style="padding-left:.4rem">
          <van-row class="num">3</van-row>
          <van-row class="text">{{$t('m.Trade')}}</van-row>
          <van-row class="text" style="font-size:.32rem">{{$t('m.Accesswr')}}</van-row>
          
        </van-col>
      </van-row>
      <van-row class="openbtn">
        <van-button type="info" size="normal"  @click="goRegister">{{$t('m.LOpeninorng')}}</van-button>
      </van-row>

   </van-row>
   <van-row class="bottom-box">
      <van-row class="logo-box">
          <img src="../assets/images/1024.png" class="logo" />
          <!-- <van-row class="title">Tyson Capital Group Co., Ltd</van-row>
          <van-row class="text">E-Mail：support@savantfxs.com</van-row> -->
      </van-row>
      <!-- <van-row class="menu-box">
         <van-col span="12">
           <van-row class="menu-title">{{$t('m.Help')}}</van-row>
           <van-row class="menu-text">{{$t('m.Beginnerguide')}}</van-row>
           <van-row class="menu-text">{{$t('m.FAQ')}}</van-row>
           <van-row class="menu-text" @click="goPage('assetintro')">{{$t('m.FADigitalQ')}}</van-row>
         </van-col>
         <van-col span="12">
           <van-row class="menu-title" >{{$t('m.LegalDocument')}}</van-row>
           <van-row class="menu-text" @click="goPage('legalDocument2')">{{$t('m.PrivacyPolicy')}}</van-row>
           <van-row class="menu-text" @click="goPage('legalDocument3')">{{$t('m.Disclaimer')}}</van-row>
           <van-row class="menu-text" @click="goPage('legalDocument1')">{{$t('m.UserAgreement')}}</van-row>
         </van-col>
      </van-row> -->
      <!-- <van-row class="menu-box" style="margin-top:.4rem">
         <van-col span="24">
           <van-row class="menu-title">{{$t('m.ContactUs')}}</van-row>
           <van-row class="menu-text">{{$t('m.Mail')}}：support@rbcoin.ltd</van-row>
           <van-row class="menu-text">{{$t('m.Address')}}：1312 17th Street Suite 692 Denver Colorado</van-row>
         </van-col>
      </van-row> -->
      <van-row class="tips-box">
         <van-row class="tips-title">
           {{$t('m.Risktips')}}
        </van-row>
         <van-row class="tips-text">
           <van-row>{{$t('m.Acinvestmentsswr')}}</van-row>
           <van-row style="margin-top:.15rem">{{$t('m.Arealizetsswr')}}</van-row>
           <van-row style="margin-top:.15rem">{{$t('m.Parklifetsswr')}}</van-row>
           <van-row style="margin-top:.15rem">{{$t('m.drtwebfetsswr')}}</van-row>
        </van-row>
      </van-row>
      <van-row class="dow-box">
        <van-row class="dow-title">
           {{$t('m.webfetsswr')}}
        </van-row>
        <van-row class="Android-box" @click="anflag = true">
          <img src="../assets/images/anzhuo-2.png"/>
           Android
        </van-row>
        <van-row class="ios-box" @click="iosflag = true">
          <img src="../assets/images/pingguo15x15.png"/>
           IOS
        </van-row>
      </van-row>
   </van-row>
  <div class="mask" v-show="anflag"></div>
  <div class="downapp-box" v-show="anflag">
    <div class="titledown">Android</div>
    <div class="appbox">
      <div class="sonbox" @click="downapp('andownuri')">
        <img src="../assets/images/sfsf.png"/>
        <div class="bottom-box" >
          Local download
        </div>
      </div>
      <div class="sonbox">
        <img src="../assets/images/sdwsa.png"/>
        <div class="bottom-box">
          GooglePlay
        </div>
      </div>
    </div>
    <div class="closeBox" @click="anflag = false">Close</div>
  </div>
  <div class="mask" v-show="iosflag"></div>
  <div class="downapp-box" v-show="iosflag">
    <div class="titledown">Ios</div>
    <div class="appbox" style="display:flex;justify-content:center;">
      <div class="sonbox">
        <img src="https://rtotc.oss-cn-hangzhou.aliyuncs.com/savant/IOS.png" style="width:2.3rem;height:2.3rem;margin-top:.47rem"/>
        <div class="bottom-box" >
          Code download
        </div>
      </div>
      <div class="sonbox" @click="downloadIphone('iphoneUri')">
        <img src="../assets/images/ffef.png"/>
        <div class="bottom-box">
          AppDownload
        </div>
      </div>
    </div>
    <div class="closeBox" @click="iosflag = false">Close</div>
  </div>
  </van-row>
</template>

<script>
import BaseConfig from '@/common/baseConfig';
import Bus from "@/common/Bus"
import { Col, Row, Button } from 'vant';
export default {
  name: 'headPage',
  components: {
    [Col.name]: Col ,
    [Row.name]: Row ,
    [Button.name]: Button ,
  },  
  data () {
    return {
      anflag: false,
      iosflag: false,
      isMedu: true,
      isyou: true,
      activeIndex: '1',
      twitter: BaseConfig.TWITTER,
      google: BaseConfig.GOOGLE,
      face: BaseConfig.FACEBOOK,
      ins: BaseConfig.INSTAG,
      TELEGR: BaseConfig.TELEGR,
      MEDIUM: BaseConfig.MEDIUM,
      YOUTU: BaseConfig.YOUTU,
    }
  },
  methods: {
    downapp(value) {
      window.location.href = BaseConfig[value]
    },
    downloadIphone(value) {
      window.open(BaseConfig[value])
      // window.location.href = BaseConfig[value]
    },
    goRegister() {
      window.location.href = BaseConfig.REGIST_URL
    },
    goLogin() {
      window.location.href = BaseConfig.LOGIN_URL
    },
    gotds(){
      if(this.$i18n.locale === 'zh-CN') {
        window.open(BaseConfig.LOGIN_URL_ZH);
      } else {
        window.open(BaseConfig.LOGIN_URL);
      }
    },
    registered() {
      if(this.$i18n.locale === 'zh-CN') {
        window.open(BaseConfig.REGIST_URL_ZH);
      } else {
        window.open(BaseConfig.REGIST_URL);
      }
    },
    hrefGoods (href,label) {
      this.$router.push({
        name: href,
        params: {
          label: label
        }
      })
    },
    hrefwai (href) {
      window.open(href);
    },
    goreg (href) {
      Bus.$emit("ieoOpenreg", 1)
    },
    goPage(value) {
      console.log(value)
      window.location.href = BaseConfig[value]
    },
    goTm(){
      window.open('http://154.209.249.119/victory.pdf');
    },
  }
}
</script>
<style  lang="stylus" scoped>
  @import "~common/stylus/footPage.styl";
</style>



// WEBPACK FOOTER //
// src/components/footPage.vue